import * as yup from 'yup';

export const getProfileFormSchema = () => {
  const schema = yup.object().shape({
    email: yup.string().trim().email().required(),
    phoneNumber: yup
      .string()
      .trim()
      .matches(/^(\+\d{1,3}[()\s]*\d{6,14})$|^(\d{9,13})$/)
      .required(),
    phoneCode: yup.string().trim().required(),
    country: yup.string().required(),
    state: yup.string().min(1).required(),
    city: yup.string().required(),
    direction: yup.string().trim().required(),
    numberId: yup.string().trim().required(),
    idType: yup.string().trim().required(),
    bornDate: yup.string().trim().required(),
    educationLevel: yup.string().trim().required(),
    institution: yup.string().trim().required(),
    title: yup.string().trim().required(),
    hasExperience: yup.boolean().default(false),
    job_end_date: yup.string().trim().nullable(),
    preferredName: yup.string().trim().required(),
    firstName: yup.string().trim().required(),
    lastName: yup.string().required(),
    secondName: yup.string().trim().nullable(),
    secondLastName: yup.string().trim().nullable(),

    jobtitle: yup
      .string()
      .trim()
      .when('hasExperience', {
        is: false,
        then: (schema) => schema.required('Este campo es obligatorio'),
        otherwise: (schema) => schema.nullable(),
      }),
    company: yup
      .string()
      .trim()
      .when('hasExperience', {
        is: false,
        then: (schema) => schema.required('Este campo es obligatorio'),
        otherwise: (schema) => schema.nullable(),
      }),
    job_start_date: yup
      .string()
      .trim()
      .when('hasExperience', {
        is: false,
        then: (schema) => schema.required('Este campo es obligatorio'),
        otherwise: (schema) => schema.nullable(),
      }),

    currentSalaryCurrency: yup
      .string()
      .trim()
      .when('hasExperience', {
        is: false,
        then: (schema) => schema.required('Este campo es obligatorio'),
        otherwise: (schema) => schema.nullable(),
      }),
    currentSalary: yup
      .string()
      .trim()
      .when('hasExperience', {
        is: false,
        then: (schema) => schema.required('Este campo es obligatorio'),
        otherwise: (schema) => schema.nullable(),
      }),

    // jobtitle: yup.string().trim().required(),
    // company: yup.string().trim().required(),
    // job_start_date: yup.string().trim().required(),
    // currentSalaryCurrency: yup.string().trim().required(),
    // currentSalary: yup.string().trim().required(),
    expectedSalaryCurrencyDropdown: yup.string().trim().required(),
    expectedSalaryNumeric: yup.string().trim().required(),
  });

  return schema;
};
